/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Record_DistanceInputs */

const en_us2_exercise_sheet_record_distance = /** @type {(inputs: Exercise_Sheet_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longest distance`)
};

const pt_br2_exercise_sheet_record_distance = /** @type {(inputs: Exercise_Sheet_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior distância`)
};

const es_419_exercise_sheet_record_distance = /** @type {(inputs: Exercise_Sheet_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor distancia`)
};

const pt_pt2_exercise_sheet_record_distance = /** @type {(inputs: Exercise_Sheet_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior distância`)
};

const fr_fr2_exercise_sheet_record_distance = /** @type {(inputs: Exercise_Sheet_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus longue distance`)
};

const de_de2_exercise_sheet_record_distance = /** @type {(inputs: Exercise_Sheet_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Längste Strecke`)
};

const it_it2_exercise_sheet_record_distance = /** @type {(inputs: Exercise_Sheet_Record_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanza più lunga`)
};

/**
* | output |
* | --- |
* | "Longest distance" |
*
* @param {Exercise_Sheet_Record_DistanceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_record_distance = /** @type {((inputs?: Exercise_Sheet_Record_DistanceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Record_DistanceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_record_distance(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_record_distance(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_record_distance(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_record_distance(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_record_distance(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_record_distance(inputs)
	return en_us2_exercise_sheet_record_distance(inputs)
});
export { exercise_sheet_record_distance as "exercise-sheet.record_distance" }